import moment from 'moment-timezone';
import React, { useEffect, useState, useRef, useContext } from 'react'
import { Col, Container, Form, FormControl, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row } from 'react-bootstrap'
import { useImmer } from 'use-immer';
import '../css/calendar.css'
import GlobalContext from '../GlobalContext';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { RiCheckLine, RiCloseLine } from 'react-icons/ri'
import { ViewState, EditingState, IntegratedEditing, } from '@devexpress/dx-react-scheduler';
import {
    Scheduler,
    DayView,
    Appointments,
    WeekView,
    MonthView,
    Toolbar,
    ViewSwitcher,
    CurrentTimeIndicator,
    DateNavigator,
    TodayButton,
    DragDropProvider,
    AllDayPanel

} from '@devexpress/dx-react-scheduler-material-ui';
import Appointment from './scheduler_custom_components/Appointment';
import { CustomDayTimeTableCell, CustomMonthTimeTableCell, CustomWeekTimeTableCell } from './scheduler_custom_components/CustomTimeTableCell'
import CustomFlexibleSpace from './scheduler_custom_components/CustomFlexibleSpace';
import ServiceContext from '../ServiceContext';
import Leftbar from './Leftbar';
import TextContext from '../TextContext';
import GoodNumber from '../components/GoodNumber';
import CalendarContext from '../CalendarContext';

const defCategories = [
    {
        ID: 0,
        cat_name: "nocategory",
        cat_apt: 0,
        cat_color: "#bbbbbbb4",
        loaded: true
    }
]
const defaultCategory =
{
    ID: 0,
    cat_name: "nocategory",
    cat_apt: 0,
    cat_color: "#bbbbbbb4",
    cat_duration: 60
}

const compNumberList=(list1,list2)=>{
    if(list1.length!==list2.length){
        return false
    }
    list1.sort()
    list2.sort()
    return list1.every((v,k)=>{
        return v==list2[k]
    })
}


const Calendar = () => {

    const navigate = useNavigate()

    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const textContext = useContext(TextContext)
    const calendarContext = useContext(CalendarContext)
    // const [unPreparedEvents, setUnPreparedEvents] = useState([])
    const [resetColors, setResetColors] = useState(true)
    const [reloadScheduler, setReloadScheduler] = useState(false)
    const [users, setUsers]=useState([])
    const resetColorsRef = useRef(false)
    const currentCalendarDate = useRef(moment(calendarContext.get.calendarDate, 'YYYY-MM-DDTHH:mm'))
    const eventsLoading=useRef(false)
    // const [message, setMessage] = useImmer({
    //     ID: globalContext.get.Shop.ID,
    //     sho_message: globalContext.get.Shop.sho_message,
    //     sho_message_time: globalContext.get.Shop.sho_message_time,
    // })
    // const [exampleMessage, setExampleMessage] = useState('')
    // const [messageChecks, setMessageCheks] = useImmer({
    //     touched: {
    //         ID: false,
    //         sho_message: false,
    //         sho_message_time: false,
    //     },
    //     check: {
    //         ID: (v) => { return true },
    //         sho_message: (v) => { return v.length > 0 && v.length < 151 },
    //         sho_message_time: (v) => { return v > 0 },
    //     },
    //     good: {
    //         ID: false,
    //         sho_message: false,
    //         sho_message_time: false,
    //     },
    //     bad: {
    //         ID: false,
    //         sho_message: false,
    //         sho_message_time: false,
    //     },
    // })

    const checkLocalStorage = () =>{
        const res=JSON.parse(localStorage.getItem(`showUsersList`))
        if(!res){
            return false
        } else {
            return true
        }
    }
    const getLocalStorage = () =>{
        return JSON.parse(localStorage.getItem(`showUsersList`))
    }
    const setLocalStorage = (item) =>{
        return localStorage.setItem(`showUsersList` ,JSON.stringify(item))
    }
    const deleteLocalStorage = () =>{
        return localStorage.setItem(`showUsersList` ,JSON.stringify(null))
    }
    const calendarDateChange = (newDate) => {
        calendarContext.set(draft => { draft.calendarDate = newDate })
        generateOpenings(moment(newDate, 'YYYY-MM-DDTHH:mm').startOf('week').add(1, 'day').format('YYYY-MM-DD'))
        if (Math.abs(currentCalendarDate.current.diff(moment(newDate, 'YYYY-MM-DDTHH:mm'), 'month', true)) > 0.9) {
            console.log('date change')
            newDate=moment(newDate, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DDT12:00')
            loadEvents(newDate)
            currentCalendarDate.current = moment(newDate, 'YYYY-MM-DDTHH:mm')
        }
    }
    const generateOpenings = (startDate) => {
        // console.log('gen openings', startDate)
        // console.log(generateHours('00:00', '23:31'))
        // console.log(checkOpen(1).filter(i=>!checkClosure('2023-12-26').includes(i)))
        const date = moment(startDate, 'YYYY-MM-DD')
        const openings = {}
        for (let i = 0; i < 7; i++) {
            openings[date.format('YYYY-MM-DD')] = checkOpen(i).filter(h => !(checkClosure(date.format('YYYY-MM-DD')).includes(h)))
            date.add(1, 'day')
        }
        calendarContext.set(draft => {
            draft.openDates = openings;
            draft.resetOpenDates = false
        })
    }
    const checkOpen = (weekDay) => {
        // console.log(calendarContext.get)
        // const startHour = moment(moment(props.startDate).format('HH:mm'), 'HH:mm')
        // const endHour = moment(moment(props.endDate).format('HH:mm'), 'HH:mm')
        const openings = globalContext.get.openings.filter(ope =>
            ope.ope_day == weekDay &&
            ope.Shop_ID == globalContext.get.selectedShop.ID
        )
        let openHours = []
        openings.forEach(ope => {
            const hours = generateHours(ope.ope_start_hour, ope.ope_end_hour)
            openHours = [...openHours, ...hours.filter(i => !openHours.includes(i))]
        })
        return openHours
    }
    const checkClosure = (date) => {
        const closeCats = globalContext.get.categories.filter(cat => cat.cat_prevent_apt).map(cat => cat.ID)
        let closeHours = []
        // console.log(closeCats)
        if (closeCats.length) {
            const closures = calendarContext.get.events.filter(eve =>
                !eve.isAppointment &&
                closeCats.includes(eve.category.value.ID) &&
                date == moment(eve.startDate, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD')
            )
            // console.log(closures)
            closures.forEach(eve => {
                if (eve.allDay) {
                    const hours = generateHours('00:00', '23:31')
                    closeHours = [...closeHours, ...hours.filter(i => !closeHours.includes(i))]
                } else {
                    const hours = generateHours(moment(eve.startDate, 'YYYY-MM-DDTHH:mm').format('HH:mm'), moment(eve.endDate, 'YYYY-MM-DDTHH:mm').format('HH:mm'))
                    closeHours = [...closeHours, ...hours.filter(i => !closeHours.includes(i))]
                }
            })
        }
        return closeHours
    }
    const generateHours = (start, end) => {
        let hour = moment(start, 'HH:mm')
        const minutes= parseInt(hour.format('mm'))
        // console.log('ora prima',hour, minutes)
        if(minutes>=30){
            hour=moment(hour.format('HH:30'), 'HH:mm')
        } else {
            hour.startOf('hour')
        }
        // console.log('ora dopo',hour)
        const hourList = []
        const lastHour = moment(end, 'HH:mm')
        while (lastHour.diff(hour, 'minutes') > 0) {
            hourList.push(hour.format('HH:mm'))
            hour.add(30, 'minutes')
        }
        return hourList
    }
    const checkForm = (values, check, setCheck, show = false) => {
        try {
            let pass = true
            Object.keys(values).forEach(k => {
                if (check.check[k](values[k])) {

                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.good[k] = true })
                        setCheck(draft => { draft.bad[k] = false })
                    }
                } else {
                    pass = false

                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.bad[k] = true })
                        setCheck(draft => { draft.good[k] = false })
                    }
                }

            })
            return pass
        } catch {
            return false
        }
    }
    // const closeMessage = () => {
    //     setMessage({
    //         ID: globalContext.get.User.ID,
    //         sho_message: globalContext.get.Shop.sho_message,
    //         sho_message_time: globalContext.get.Shop.sho_message_time,
    //     })
    //     setMessageCheks({
    //         touched: {
    //             ID: false,
    //             sho_message: false,
    //             sho_message_time: false,
    //         },
    //         check: {
    //             ID: (v) => { return true },
    //             sho_message: (v) => { return v.length > 0 && v.length < 151 },
    //             sho_message_time: (v) => { return v > 0 },
    //         },
    //         good: {
    //             ID: false,
    //             sho_message: false,
    //             sho_message_time: false,
    //         },
    //         bad: {
    //             ID: false,
    //             sho_message: false,
    //             sho_message_time: false,
    //         },
    //     })
    //     setShowMessage(false)
    // }
    const DndChecker = (isAppointment, ID) => {
        // console.log('dnd', ID, isAppointment)
        if (ID < 0) {
            return false
        }
        if (isAppointment && getPermission('gro_aer_apt', 1)) {
            return true
        }
        if (!isAppointment && getPermission('gro_aer_event', 1)) {
            return true
        }
    }
    // const editMessage = async () => {
    //     let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/shops`, {
    //         method: 'PUT',
    //         credentials: 'include',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify(message)
    //     })
    //     const respValue = await resp.json()
    //     globalContext.set(draft => { draft.Shop.sho_message = message.sho_message; draft.Shop.sho_message_time = message.sho_message_time })
    //     closeMessage()
    // }
    const getColor = (ID) => {
        const res = globalContext.get.categories.filter(cat => cat.ID == ID)
        if (res.length > 0) {
            return res[0].cat_color
        } else {
            return defCategories.cat_color
        }
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    // const isOpen = (checkDate) => {
    //     const startHour = moment(checkDate).format('HH:mm')
    //     const date=moment(checkDate).format('YYYY-MM-DD')
    //     // console.log(calendarContext.get.openDates)
    //     if(calendarContext.get.openDates[date]&&calendarContext.get.openDates[date].includes(startHour)){
    //         return true
    //     } else {
    //         return false
    //     }

    // }
    const handleDndEdit = async (changeSet) => {
        console.log(changeSet)
        Object.keys(changeSet.changed).forEach(async k => {
            const rawData = changeSet.changed[k]
            // if(!isOpen(rawData.startDate)||!isOpen(rawData.endDate))
            if (k > 0) {
                const body = {
                    ID: k,
                    eve_start: moment(rawData.startDate).unix(),
                    eve_end: moment(rawData.endDate).unix(),
                    mode: 0
                }
                const event = JSON.parse(JSON.stringify(calendarContext.get.events)).filter(eve => eve.id == k)[0]
                event.startDate = rawData.startDate
                event.endDate = rawData.endDate
                // console.log(
                calendarContext.set(draft => { draft.events = [...[event], ...JSON.parse(JSON.stringify(calendarContext.get.events)).filter(eve => eve.id != k)] })

                const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/events`, {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body)
                })
                // globalContext.set(draft => { draft.Reloads.events = true })
            } else {
                serviceContext.set(draft => {
                    draft.Alerts.push({
                        ID: Math.random(),
                        message:textContext.get(['calendar', 'notify'], ['none'], textContext.value),
                        ttl: 2000
                    })
                })
            }
        })
    }
    const addEvent = () =>{
        const event=JSON.parse(JSON.stringify(globalContext.get.Reloads.events))
        globalContext.set(draft=>{draft.Reloads.events=false})
        calendarContext.set(draft=>{draft.rawEvents=[...draft.rawEvents.filter(eve=>eve.ID!=event.ID), event]})

    }
    const loadEvents = async (date = false) => {
        console.log('load Events')
        globalContext.set(draft => { draft.EventsLoaded = true; draft.Reloads.events = false })
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        let resp
        if (date) {
            resp = await fetch(`${globalContext.get.backendUrl}/papiv1/events?start=${moment.utc(date, 'YYYY-MM-DDTHH:mm').add(-1, "month").unix()}&end=${moment.utc(date, 'YYYY-MM-DDTHH:mm').add(1, "month").unix()}`, {
                method: 'GET',
                credentials: 'include'
            })
        } else {
            resp = await fetch(`${globalContext.get.backendUrl}/papiv1/events?start=${moment.utc().add(-1, "month").unix()}&end=${moment.utc().add(1, "month").unix()}`, {
                method: 'GET',
                credentials: 'include'
            })
        }
        const respValue = await resp.json()
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        if (resp.status == 200) {
            calendarContext.set(draft=>{
                draft.rawEvents=respValue.data
            })
        }
        eventsLoading.current=false
    }
    // const preloadMessage = () => {
    //     const start = message.sho_message
    //     if (start) {
    //         let mess = start.split("%name%").join('Daniel')
    //         mess = mess.split("%time%").join('12:44')
    //         mess = mess.split("%surname%").join('Müller')
    //         setExampleMessage(mess)
    //     }
    // }
    const prepareEvents = (rawEvents) => {
        const postEvents = []
        //GENERAZIONE EVENTI NORMALI
        rawEvents.filter(eve => 
            eve.Shop_ID == globalContext.get.selectedShop.ID
        ).forEach((event, i) => {
            //get categoria
            let cat = globalContext.get.categories.filter(cate => cate.ID == event.Category_ID)[0]
            if (!cat) {
                cat = defaultCategory
            }

            //check se è nel filtro utenti
            if(!globalContext.get.showUsersList.includes( event.eve_owner_ID?event.eve_owner_ID:event.User_ID)&&!cat.cat_global){
                return
            }

            //get creatore
            let creator = users.filter(use=>use.ID==event.User_ID)
            if(creator.length>0){
                creator=creator[0]
            } else {
                creator={use_color:"1000be", use_username: 'error'}
            }

            //get owner
            let owner
            if(event.eve_owner_ID){
                owner = users.filter(use=>use.ID==event.eve_owner_ID)
            } else {
                owner = [creator]
            }
            if(owner.length>0){
                owner=owner[0]
            } else {
                owner={use_color:"1000be"}
            }

            //generazione titolo
            let title=event.eve_title
            if(event.eve_autogen_title){
                if(event.Appointment_ID&&event.Appointment&&event.Appointment.Customer) {
                    const customer=event.Appointment.Customer
                    title=`${cat.cat_name} ${customer.cus_name} ${customer.cus_surname}`
                } else {
                    title=`${cat.cat_name}`
                }
            }

            let start
            let end
            if(event.rec_ID){
                start= moment.utc(event.eve_start, 'X').tz(globalContext.get.selectedShop.sho_timezone).format("YYYY-MM-DDTHH:mm")
                end= moment.utc(event.eve_end, 'X').tz(globalContext.get.selectedShop.sho_timezone).format("YYYY-MM-DDTHH:mm")
            } else {
                start= moment.utc(event.eve_start, 'X').tz(globalContext.get.selectedShop.sho_timezone).format("YYYY-MM-DDTHH:mm")
                end= moment.utc(event.eve_end, 'X').tz(globalContext.get.selectedShop.sho_timezone).format("YYYY-MM-DDTHH:mm")
            }

            postEvents.push({
                id: event.ID,
                key: parseInt(`${event.ID}${parseInt(Math.random()*100)}`),
                rec_ID: event.rec_ID,
                red_ID: event.red_ID,
                rec_index: event.rec_index,
                title: title,
                startDate: start,
                endDate: end,
                color: getColor(event.Category_ID),
                disabled: event.eve_disabled,
                editable: event.eve_editable,
                deletable: event.eve_deletable,
                draggable: event.eve_draggable,
                allDay: event.eve_allDay,
                note: event.eve_note,
                customer_info: `${event.Appointment_ID ? event.Appointment.Customer.cus_name : ""} ${event.Appointment_ID ? event.Appointment.Customer.cus_surname : ""}`,
                category: { label: cat.cat_name, value: { ID: cat.ID, apt: cat.cat_apt } },
                price: cat.cat_price,
                isGlobal: cat.cat_global,
                isAppointment: event.Appointment_ID ? true : false,
                aptID: event.Appointment_ID ? event.Appointment_ID : false,
                customer: event.Appointment_ID ? { label: `${event.Appointment.Customer.cus_name} ${event.Appointment.Customer.cus_surname ? event.Appointment.Customer.cus_surname : ''}`, value: event.Appointment.Customer.ID } : undefined,
                contact: event.Appointment_ID ? event.Appointment.apt_contact : true,
                isDraggable: DndChecker(event.Appointment_ID ? true : false, event.ID),
                eve_autogen_title: event.eve_autogen_title,
                owner: owner,
                creator: creator
            })
            // if(event.ID==255){
            //     console.log('eve 255')
            //     console.log(event.eve_start)
            //     console.log(moment.utc(event.eve_start, 'X').format("YYYY-MM-DDTHH:mm"))
            //     console.log(moment(event.eve_start, 'X'))
            //     console.log(moment(event.eve_start, 'X').tz(globalContext.get.selectedShop.sho_timezone).format("YYYY-MM-DDTHH:mm"))
            // }
        })

        //GENERAZIONE COMPLEANNI
        


        calendarContext.set(draft => {
            draft.events = postEvents;
            draft.resetOpenDates = true;
        })
        // console.log(postEvents)

        //console.log('calendarContext.get.events setted', postEvents)
    }

    useEffect(()=>{
        // console.log(textContext.value.activeLang)
    },[])
    useEffect(() => {
        if (calendarContext.get.resetOpenDates) {
            generateOpenings(moment(calendarContext.get.calendarDate, 'YYYY-MM-DDTHH:mm').startOf('week').add(1, 'day').format('YYYY-MM-DD'))
        }
        if (calendarContext.get.changeDate){
            calendarDateChange(calendarContext.get.changeDate)
            calendarContext.set(draft=>{draft.changeDate=false})
        }
    }, [calendarContext.get])
    useEffect(() => {
        // console.log(globalContext.get.User)
        if (resetColorsRef.current) {
            setResetColors(false)
            resetColorsRef.current = false
        }
        if (globalContext.get) {
            if (!globalContext.get.EventsLoaded) {
                if (globalContext.get.selectedShop.ID) {
                    console.log('reload or not loaded', globalContext.get.Reloads.events, globalContext.get.EventsLoaded)
                    if(!eventsLoading.current){
                        eventsLoading.current=true
                        loadEvents(calendarContext.get.calendarDate)
                    }
                }
            }
            if (globalContext.get.Reloads.events) {
                if(globalContext.get.Reloads.events.ID){
                    addEvent()
                } else {
                    if(!eventsLoading.current){
                        eventsLoading.current=true
                        loadEvents(calendarContext.get.calendarDate)
                    }
                }
            // console.log('load events reload')
            }
            if (globalContext.get.User.ID && globalContext.get.Shop.ID && globalContext.get.Agency.ID) {
                let l_users = []
                let ids = []
                globalContext.get.shops.forEach(sho => {
                    sho.Users.forEach(use => {
                        if (!ids.includes(use.ID)) {
                            ids.push(use.ID)
                            l_users.push(use)
                        }
                    })
                })
                setUsers(l_users)
            }
        }
    }, [globalContext.get])
    useEffect(()=>{
        if (globalContext.get) {
            if (globalContext.get.User.ID){
                if(globalContext.get.showUsersList){
                    if(globalContext.get.showUsersList===1){
                        //Reset lista
                        deleteLocalStorage()
                        globalContext.set(draft=>{draft.showUsersList=2})
                    } else if(globalContext.get.showUsersList!==2) {
                        const userList=getLocalStorage()
                        if(!compNumberList(userList, JSON.parse(JSON.stringify(globalContext.get.showUsersList)))){
                            // console.log('userList modificata')
                            setLocalStorage(globalContext.get.showUsersList)
                        } else {
                            // console.log('userList non modificata')
                        }
                    }
                } else {
                    if(checkLocalStorage()){
                        //Già inizializzata
                        globalContext.set(draft=>{draft.showUsersList=getLocalStorage()})
                    } else {
                        //da inizializzare
                        setLocalStorage([globalContext.get.User.ID])
                        globalContext.set(draft=>{draft.showUsersList=[globalContext.get.User.ID]})
                    }
                }
            }
        }
        if(globalContext.get.showUsersList&&![1,2].includes(globalContext.get.showUsersList)){
            prepareEvents(calendarContext.get.rawEvents)
        }
    },[globalContext.get.showUsersList, calendarContext.get.rawEvents, users])
    useEffect(() => {
        calendarContext.set(draft=>{draft.currentView=textContext.get(['calendar', 'view_select'], ['week'], textContext.value)})
        setReloadScheduler(true)
    }, [textContext.value])
    useEffect(() => {
        setResetColors(true)
    }, [resetColors])
    useEffect(()=>{
        if(globalContext.get.showUsersList&&![1,2].includes(globalContext.get.showUsersList)){
            prepareEvents(calendarContext.get.rawEvents)
        }
    },[calendarContext.get.currentView])
    useEffect(() => {
        if (reloadScheduler) {
            setReloadScheduler(false)
        }
    }, [reloadScheduler])
    

    return (
        <Container fluid style={{ backgroundColor: globalContext.get.Theme.palette[1], height: '99.5%', margin: 0, color: globalContext.get.Theme.palette[3] }}>
            <Row className='' >
                <Sidebar />
                <Col xs={10} className='  calendar-scheduler-container' >
                    {reloadScheduler ?
                        (<div />) : (
                            <Scheduler
                                data={calendarContext.get.events}
                                locale={textContext.value.activeLang}
                                firstDayOfWeek={1}
                            >
                                <ViewState
                                    defaultCurrentDate={moment().format('YYYY-MM-DDTHH:mm')}
                                    onCurrentDateChange={calendarDateChange}
                                    currentDate={calendarContext.get.calendarDate}
                                    defaultCurrentViewName={textContext.get(['calendar', 'view_select'], ['week'], textContext.value)}
                                    currentViewName={calendarContext.get.currentView}
                                    onCurrentViewNameChange={(e)=>{calendarContext.set(draft=>{draft.currentView=e})}}
                                />
                                <EditingState
                                    onCommitChanges={handleDndEdit}
                                />
                                <IntegratedEditing />
                                <DayView
                                    name={textContext.get(['calendar', 'view_select'], ['day'], textContext.value)}
                                    startDayHour={globalContext.get.User.use_calendar_start}
                                    endDayHour={globalContext.get.User.use_calendar_end}
                                    timeTableCellComponent={CustomDayTimeTableCell}
                                    cellDuration={30}
                                />
                                <WeekView
                                    name={textContext.get(['calendar', 'view_select'], ['week'], textContext.value)}
                                    startDayHour={globalContext.get.User.use_calendar_start}
                                    endDayHour={globalContext.get.User.use_calendar_end}
                                    timeTableCellComponent={CustomWeekTimeTableCell}
                                    cellDuration={30}
                                />
                                <MonthView
                                    name={textContext.get(['calendar', 'view_select'], ['month'], textContext.value)}
                                    startDayHour={globalContext.get.User.use_calendar_start}
                                    endDayHour={globalContext.get.User.use_calendar_end}
                                    timeTableCellComponent={CustomMonthTimeTableCell}
                                    cellDuration={60}
                                />
                                <Toolbar
                                    flexibleSpaceComponent={CustomFlexibleSpace}
                                />
                                <DateNavigator />
                                <TodayButton
                                    messages={{ today: textContext.get(['calendar'], ['today'], textContext.value) }}
                                />
                                <ViewSwitcher
                                />

                                <Appointments
                                    appointmentComponent={Appointment}
                                />

                                <AllDayPanel
                                    messages={{ allDay: '' }}
                                />
                                <DragDropProvider
                                />
                                <CurrentTimeIndicator
                                    shadePreviousCells={false}
                                    shadePreviousAppointments={true}
                                    updateInterval={60 * 1000}
                                />
                            </Scheduler>
                        )}
                </Col>
                <Leftbar />
            </Row>
        </Container>
    )
}

export default Calendar